import { styled } from '@mui/material';

import { StyledFormControlLabel } from '@/components/FormElementRadioGroup/FormElementRadioGroupStyled';

export const OffersPageCheckbox = styled(StyledFormControlLabel)`
  margin: 20px 0;
  max-width: 149px;
`;
